import React from 'react';
import styles from './styles.sass';

export const AMPWaveBack = () => (
  <div className={styles.wave}>
    <svg viewBox="0 0 1287 150" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="a">
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity=".5" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M0 385.77C68.76 373 60.4 350.67 118.99 351c72.9.41 101.48 58.75 150.95 72.82 36.52 10.38 117.27-56.37 172.3-57 58.9-.67 71.45 47.85 185.59 51.36 40.83 1.26 125.13-58.38 175.46-51.36 40.68 5.68 117.25 33.37 164.77 27.7 47.52-5.67 90.08-32.5 142.71-35.55 41.99-2.44 114.69 35.83 148.2 35.55 33.87-.29 49.34-12.45 70.57-16.86 33.43-6.94 57.72 2.25 76.5 8.11 6.64 2.08 11.36 1.51 15.63 1.43 4.26-.09 12.33-1.43 12.33-1.43V506H0V385.77z"
        transform="translate(-117 -351)"
        fill="url(#a)"
        fillRule="evenodd"
        opacity=".5"
      />
    </svg>
  </div>
);

export const AMPWaveMiddle = () => (
  <div className={styles.wave}>
    <svg viewBox="0 0 1287 150" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="wave2">
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity=".5" offset="100%" />
        </linearGradient>
      </defs>
      <path
        d="M31 388.13s69.99 41.77 128.57 42.12c54.9.34 111.87-35.82 157.78-47.18 15.04-3.73 28.89-4.79 41.1-1.04 36.5 11.21 58.67 48.9 113.7 48.22 58.89-.73 63.8-52.02 177.93-48.22 40.83 1.36 107.6 40.64 157.93 48.22 40.68 6.13 110.41-54 157.93-60.12 47.53-6.12 123.21 48.69 175.85 45.39 40.56-2.55 100.81-47.49 135.07-50.8 4.7-.21 5.99-.34 7.3-.46 7.7-.24 11.21-.26 11.21-.26l7.42.04c3.45.02 7.02.46 10.47.48 0 0 23.85.66 57.18 17.5 28.64 14.48 52.3 11.67 67.43 11.12 17.93-.64 27.13-3.98 27.13-3.98V519H31V388.13z"
        transform="translate(-117 -364)"
        fill="url(#wave2)"
        fillRule="evenodd"
      />
    </svg>
  </div>
);

export const AMPWaveFront = ({ fill = '#FFFFFF' }) => (
  <div className={styles.frontWave}>
    <svg viewBox="0 0 1287 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="cc">
          <stop stopColor="#FFF" offset="0%" />
          <stop stopColor="#FFF" stopOpacity=".5" offset="100%" />
        </linearGradient>
        <path
          d="M31 422.7c60.94 2.97 30.91 18.7 89.5 18.87 72.9.21 70.55-21.54 120.02-14.49 36.52 5.21 53.8 28.6 108.83 28.28 58.9-.34 90.9-47.1 205.05-45.34 40.83.63 115.05 38.25 165.38 41.77 40.68 2.85 120.55-43.34 168.07-46.18 47.53-2.85 111.93 37.5 164.56 35.96 42-1.22 83.34-41.43 116.85-41.57 33.86-.14 49.14 21.14 111.74 35.84 23.38 5.49 54.97 5.65 85.37 3.7 25.89-1.65 49.84-11.85 68.2-14.58 18.37-2.74 30.43-2.27 30.43-2.27V483H31v-60.3z"
          id="bb"
        />
        <filter
          x="-1.3%"
          y="-30.7%"
          width="102.7%"
          height="147%"
          filterUnits="objectBoundingBox"
          id="aa"
        >
          <feOffset
            dx="1"
            dy="-6"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          />
          <feGaussianBlur
            stdDeviation="5.5"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          />
          <feColorMatrix
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0525928442 0"
            in="shadowBlurOuter1"
          />
        </filter>
      </defs>
      <g transform="translate(-117 -383)" fill="none" fillRule="evenodd">
        <use fill="#000" filter="url(#aa)" xlinkHref="#bb" />
        <use fill="url(#cc)" xlinkHref="#bb" />
        <use fill={fill} xlinkHref="#bb" />
      </g>
    </svg>
  </div>
);
